var map = {
	"./P1_front_foot_120mm.png": "c9c4",
	"./P1_side_foot_120mm.png": "e76f",
	"./P1_side_left.png": "a4a8",
	"./P1_side_right.png": "a0b6",
	"./P1_side_right2.png": "587b",
	"./P2_front_foot_46mm.png": "f3b7",
	"./P2_front_foot_60mm.png": "b454",
	"./P2_side_foot_46mm.png": "1db7",
	"./P2_side_foot_60mm.png": "c616",
	"./P2_side_left.png": "a068",
	"./P2_side_right.png": "0375",
	"./P2_side_right2.png": "1c30",
	"./bg_wall.png": "c6e3",
	"./btn_move.png": "991a",
	"./btn_move_hover.png": "056a",
	"./btn_move_left.png": "0e86",
	"./btn_move_up.png": "1552",
	"./btn_move_up_pressed.png": "4534",
	"./front_P1.png": "4f21",
	"./front_P2.png": "bd59",
	"./screen_side.png": "eab9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d61a";